'use client';
import { useState } from 'react';
import Globe from '@/components/Globe';
import SplashScreen from '@/components/SplashScreen';

export default function Page() {
  const [dataReady, setDataReady]   = useState(false);
  const [splashDone, setSplashDone] = useState(false);

  return (
    <>
      <div style={{ position: 'absolute', width: '1px', height: '1px', padding: 0, margin: '-1px', overflow: 'hidden', clip: 'rect(0,0,0,0)', whiteSpace: 'nowrap', border: 0 }}>
        <h1>Atmosphere 8K - Live Global Wind Vector Dynamics</h1>
        <h2>Real-time Planetary Physics and Atmosphere Simulation</h2>
        <p>Atmosphere 8K is a browser-based 3D simulation engine mapping live atmospheric weather patterns from NOAA GFS and Open-Meteo across high-resolution 8K planetary textures including Earth, Mars, Venus, Jupiter, and the Moon. Featuring over 45,000 animated particles displaying true-to-life fluid velocity and atmospheric vector fields.</p>
      </div>
      {!splashDone && (
        <SplashScreen
          isDataReady={dataReady}
          onComplete={() => setSplashDone(true)}
        />
      )}
      <Globe onReady={() => setDataReady(true)} />
    </>
  );
}